export function injectScriptInHead(
  url: string,
  onLoad?: (this: GlobalEventHandlers, ev: Event) => any
) {
  try {
    const scriptEl = document.createElement('script');
    scriptEl.src = url;
    scriptEl.type = 'text/javascript';
    scriptEl.async = true;
    if (onLoad) scriptEl.onload = onLoad;
    document.head.appendChild(scriptEl);
  } catch (e) {
    console.error('Error injecting script:', e);
  }
}

export function getLanguageFromLocale(locale: string) {
  return locale.split('-')[0];
}

/** OneTrust Helper Util - Injects script in head tag
 * @param `url` optionally sets the script src value.
 * @param `innerHtml` optionally sets the innerHTML content of the script.
 * @param `datadomainscript` optionally sets the attribute `data-domain-script` with this value.
 */
export function injectScriptInHeadWith(
  url?: string,
  innerHtml?: string,
  datadomainscript?: string
) {
  try {
    const scriptEl = document.createElement('script');
    if (url) {
      scriptEl.src = url;
    }
    if (innerHtml) {
      scriptEl.innerHTML = innerHtml;
    }
    if (datadomainscript) {
      scriptEl.setAttribute('data-domain-script', datadomainscript);
      scriptEl.setAttribute('data-document-language', 'true');
    }
    scriptEl.type = 'text/javascript';
    document.head.appendChild(scriptEl);
  } catch (e) {
    console.error(e);
  }
}

/** OneTrust Helper Util - Loads text/javascript type script with cookie category class to be auto blocked by OneTrust   */
export function injectCategorizedScriptInHead(url: string, category = '') {
  try {
    const scriptEl = document.createElement('script');
    scriptEl.src = url;
    scriptEl.type = 'text/javascript';
    scriptEl.className = category;
    scriptEl.async = true;
    document.head.appendChild(scriptEl);
  } catch (e) {
    console.error(e);
  }
}

export function injectScriptInBody(script_text: string, scriptid?: string) {
  try {
    const isElementAlreadyInDocument = document.getElementById(scriptid ?? '');
    if (!isElementAlreadyInDocument) {
      const scriptEl = document.createElement('script');
      const scripttext = document.createTextNode(script_text);
      scriptEl.appendChild(scripttext);
      scriptEl.type = 'text/javascript';
      scriptEl.async = true;
      scriptEl.id = scriptid ? scriptid : '';
      document.body.appendChild(scriptEl);
    }
  } catch (e) {
    console.error(e);
  }
}

export function checkListForPath(list: string[], pathname: string) {
  if (!list) return false;
  return list.some((path) => {
    const lastChar = path[path.length - 1];
    if (lastChar && lastChar === '*') {
      const subPath = path.slice(0, -1);
      return pathname.includes(subPath);
    }
    return pathname === path;
  });
}
